const commonMemoryBank = {
  memoryBank: `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`
}
/**
 * Asset URL prefixes.
 *
 * Keep the original folder layout for all environments.
 */
const assetPaths = {
  imgBase: '/assets/img/',
  fontsBase: '/assets/fonts/',
  jsonBase: '/assets/json/',
  i18nBase: '/assets/i18n/',
  pdfBase: '/assets/pdf/',
};

export const environments = {
  localhost: {
    production: false,
    multiOneAPIUrl: 'https://api.dev.multione.signify.com/',
    multiOneAPIBaseReadUrl: 'http://localhost:2020',
    log: false,
    flags: {
      useNewHeader: false
    },
    oauth: {
      authoriserDomain: 'alhnxkfca',
      clientId: 'a1066ba3-7ed8-41e0-a784-30efe31428e2'
    },
    commonMemoryBank,
    ...assetPaths,
  },
  dev: {
    production: false,
    multiOneAPIUrl: 'https://api.dev.multione.signify.com/',
    multiOneAPIBaseReadUrl: 'http://localhost:2020',
    log: false,
    flags: {
      useNewHeader: false
    },
    oauth: {
      authoriserDomain: 'alhnxkfca',
      clientId: 'a1066ba3-7ed8-41e0-a784-30efe31428e2'
    },
    commonMemoryBank,
    ...assetPaths,
  },
  tst: {
    production: false,
    multiOneAPIUrl: 'https://api.tst.multione.signify.com/',
    multiOneAPIBaseReadUrl: 'http://localhost:2020',
    log: false,
    flags: {
      useNewHeader: false
    },
    oauth: {
      authoriserDomain: 'alhnxkfca',
      clientId: 'a1066ba3-7ed8-41e0-a784-30efe31428e2'
    },
    commonMemoryBank,
    ...assetPaths,
  },
  staging: {
    production: false,
    multiOneAPIUrl: 'https://api.staging.multione.signify.com/',
    multiOneAPIBaseReadUrl: 'http://localhost:2020',
    log: false,
    flags: {
      useNewHeader: false
    },
    oauth: {
      authoriserDomain: 'ayffos6hz',
      clientId: '7ff2f2d6-6a2b-465f-880f-a9112e6a0183'
    },
    commonMemoryBank,
    ...assetPaths,
  },
  prod: {
    production: true,
    multiOneAPIUrl: 'https://api.multione.signify.com/',
    multiOneAPIBaseReadUrl: 'http://localhost:2020',
    log: false,
    flags: {
      useNewHeader: false
    },
    oauth: {
      authoriserDomain: 'ayffos6hz',
      clientId: '7ff2f2d6-6a2b-465f-880f-a9112e6a0183'
    },
    commonMemoryBank,
    ...assetPaths,
  }
};
function detectEnvironment() {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') {
    return environments.localhost;
  } else if (hostname.includes('dev')) {
    return environments.dev;
  } else if (hostname.includes('tst')) {
    return environments.tst;
  } else if (hostname.includes('staging')) {
    return environments.staging;
  } else  {
    return environments.prod;
  }
}


export const environment = detectEnvironment();
